import React from 'react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  headline: string;
  label?: string;
  dark?: boolean;
};

/** Transformational CTA placed at the end of each section. */
export function SectionCTA({
  headline,
  label,
  dark = false
}: SectionCTAProps) {
  return <div className="mx-auto mt-10 w-full max-w-md" data-id="element-57" data-mp="1qbo388covec3">
      <p className={`mb-3 text-center font-display text-lg italic leading-snug ${dark ? 'text-white' : 'text-ink'}`} data-id="element-58" data-mp="1qad0mbuzccmk">
        {headline}
      </p>
      <CTAButton label={label} note="One-time payment · Lifetime access · 7-day guarantee" data-id="element-59" data-mp="1gejr71ck4z90" />
    </div>;
}